export default __webpack_public_path__ + "static/media/medicine_supply.719384e8.png";